import 'react-loading-skeleton/dist/skeleton.css';
import '@styles/globals.css';

import { RoutesConfig } from '@app/routes';
import AnalyticsRouteTracker from '@components/AnalyticsRouteTracker';
import { GlobalDialpad } from '@components/GlobalDialpad';
import { Toaster } from '@components/ui/sonner';
import { queryClient } from '@services/query.config';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import { BrowserRouter } from 'react-router-dom';

import { AvailabilityProvider } from '@/contexts/AvailabilityContext';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AvailabilityProvider>
        <BrowserRouter>
          <SkeletonTheme baseColor="hsl(var(--muted))" highlightColor="hsl(var(--primary))">
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: 'hsl(var(--background))',
                  color: 'hsl(var(--foreground))',
                  border: '1px solid hsl(var(--border))',
                  padding: '16px',
                  paddingRight: '32px',
                },
                duration: 4000,
              }}
              style={{
                bottom: 20,
                right: 20,
              }}
            />
            <AnalyticsRouteTracker />
            <RoutesConfig />
            <GlobalDialpad />
          </SkeletonTheme>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </AvailabilityProvider>
    </QueryClientProvider>
  );
}
